import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AutomaticDebitService } from '../../services/automatic-debit.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { AutomaticDebitRetFile } from '../../models/automaticDebitRetFile';
import { NotificationsService } from 'angular2-notifications';
import { FileService } from 'src/app/services/file.service';
import { Router } from '@angular/router';
import { FileType } from '../../models/inputModels';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';

@Component({
    selector: 'automatic-debit-ret-table',
    templateUrl: './automatic-debit-ret-table.component.html',
    styleUrls: ['./automatic-debit-ret-table.component.scss'],
})
export class AutomaticDebitRetTableComponent implements OnInit {
    beginDateStr: string;
    endDateStr: string;

    fileListPaginated: AutomaticDebitRetFile[] = [];
    breadcrumbItems = [
        { label: 'Arquivos REM', route: 'automatic-debit/rem', active: false },
        { label: 'Arquivos RET', route: 'automatic-debit/ret', active: true },
        { label: 'Importar RET', route: 'automatic-debit/ret/import', active: false },
    ];
    constructor(
        private automaticDebitService: AutomaticDebitService,
        private spinner: NgxSpinnerService,
        private sessionBusiness: SessionBusiness,
        private _cdRef: ChangeDetectorRef,
        private notificationsService: NotificationsService,
        private fileService: FileService,
        private router: Router,
        private _dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.beginDateStr = this.getToday(-7);
        this.endDateStr = this.getToday();
    }

    formatYYYYMMDD(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    getToday(days?: number): string {
        let date = new Date();
        if (days) {
            date.setDate(date.getDate() + days);
        }
        return this.formatYYYYMMDD(date);
    }

    selectFile(fileId: string) {
        this.router.navigate(['automatic-debit/ret/select-file'], { queryParams: { id: fileId } });
    }

    loadPaginator() {
        let legalEntityId = this.sessionBusiness.LegalEntityIdContext;
        this.spinner.show();

        let beginDate = new Date(this.beginDateStr);
        let endDate = new Date(this.endDateStr);

        let beginDateFormat = this.formatYYYYMMDD(beginDate);
        let endDateeFormat = this.formatYYYYMMDD(endDate);

        this.automaticDebitService
            .GetFilesRt(legalEntityId, beginDateFormat, endDateeFormat)
            .subscribe((result: any) => {
                if (result && result.success) {
                    this.fileListPaginated = result.data.result;
                }
                this.spinner.hide();
                this._cdRef.detectChanges();
            });
    }

    btnSearch() {
        this.loadPaginator();
    }

    navigateTo(route: string) {
        this.router.navigate([route]);
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    deleteFile(fileId: string) {
        this.yesOrNoDialog('Atenção', 'Deseja confirmar a Exclusão do arquivo?').subscribe((result) => {
            if (result) {
                this.spinner.show();

                this.fileListPaginated = this.fileListPaginated.filter((file) => file.id !== fileId);

                this.automaticDebitService.deleteRetId(fileId).subscribe(() => {
                    this.notificationsService.success(`Excluído com sucesso`);
                    this.spinner.hide();
                });
            }
        });
    }

    downloadFile(file: AutomaticDebitRetFile) {
        this.spinner.show();

        this.automaticDebitService.DownloadFile(file.id, FileType.Ret).subscribe(
            (response) => {
                this.fileService.downloadFile(response);
                this.notificationsService.success(`Download completo!`);
                this.spinner.hide();
            },
            (error) => {
                console.error('Erro', error);
                this.spinner.hide();
            },
        );
    }
}
